/**
 * Deployable hit points and removal, kept apart from the deployable behaviours so weapons,
 * projectiles and deployables can all import it without a cycle.
 */
import { emit } from './tick.js';
export function removeDeployable(t, d) {
    if (!t.s.deployables.includes(d))
        return;
    t.s.deployables = t.s.deployables.filter((x) => x.id !== d.id);
    emit(t, { t: 'deployableDestroyed', id: d.id, kind: d.kind, position: { ...d.position } });
}
/** Damages a destructible deployable; indestructible kinds (maxHp 0) ignore it. */
export function damageDeployable(t, d, amount, _source) {
    if (d.maxHp <= 0 || amount <= 0)
        return;
    d.hp -= amount;
    if (d.hp <= 0)
        removeDeployable(t, d);
}
//# sourceMappingURL=deployable-damage.js.map